import {BrowserModule} from '@angular/platform-browser';
import {inject, isDevMode, NgModule, provideAppInitializer} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {
    appReducer,
    AuthModule,
    CoreModule,
    CoreRoutingModule,
    metaReducers,
    PageModule,
    SettingsService,
    SpinnerModule
} from '@gallaghercp/core-frontend';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatExpansionModule} from '@angular/material/expansion';
import {TranslateModule} from '@ngx-translate/core';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {RECAPTCHA_SETTINGS, RecaptchaSettings} from 'ng-recaptcha';
import {StoreModule} from '@ngrx/store';
import {APP_CONFIG as LOCAL_APP_CONFIG} from './app.config';
import {MockDataInterceptor} from '@core-app/mocking/mock-data.interceptor';
import {CurrencyPipe} from '@angular/common';
import {ServiceWorkerModule} from '@angular/service-worker';

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        CoreRoutingModule,
        AppRoutingModule,
        CoreModule,
        AuthModule,
        BrowserAnimationsModule,
        MatExpansionModule,
        TranslateModule,
        PageModule,
        SpinnerModule,
        StoreModule.forRoot(
            {app: appReducer},
            {metaReducers}
        ),
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerImmediately'
        }),
    ],
    providers: [
        provideAppInitializer(() => {
            const initializerFn = (initialiseAppConfig)(inject(SettingsService));
            return initializerFn();
        }),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MockDataInterceptor,
            multi: true,
        },
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: {
                siteKey: '6LejOVIeAAAAAD6_C3KDkBNeNg5ogKOCUqY2E-gQ',
            } as RecaptchaSettings,
        },
        provideHttpClient(withInterceptorsFromDi()),
        CurrencyPipe,
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}

export function initialiseAppConfig(settings: SettingsService): () => Promise<any> {
    return () => settings.init(LOCAL_APP_CONFIG);
}
